import React, { useEffect, useState, useMemo } from 'react';
import { Layout, Card, Row, Col, Button, Typography, Select, List, Avatar, Divider, Modal, Form, InputNumber, Input, message, Tooltip } from 'antd';
import {
  UserOutlined
} from '@ant-design/icons';
import "./karma.css";
import gift from '../../assets/KarmaIcons/gift.png';
import partyGIF from '../../assets/KarmaIcons/partyGIF.gif';
import UpGraph from '../../assets/KarmaIcons/UpGraph';
import HistoryIcon from '../../assets/KarmaIcons/HistoryIcon';
import Trophylsner from '../../assets/KarmaIcons/waffle.png';
import totalWaffel from '../../assets/KarmaIcons/mothlyWaff.png';
import remaingWaffle from '../../assets/KarmaIcons/remaingWaffle.png';
import sendwaffle from '../../assets/KarmaIcons/totalWaffel.png';
import Top1 from '../../assets/KarmaIcons/top1.png';
import Top2 from '../../assets/KarmaIcons/top2.png';
import Top3 from '../../assets/KarmaIcons/top3.png';
import Top4 from '../../assets/KarmaIcons/top4.png';
import Top5 from '../../assets/KarmaIcons/top5.png';





import ltr from '../../assets/KarmaIcons/ltr.svg';

import axios from "axios";

import config from "../../permission/config.json"

import DownIcon from '../../assets/KarmaIcons/DownIcon';
import Service from '../../service';
import { useDispatch, useSelector } from 'react-redux';
import { hideAuthLoader } from '../../appRedux/actions/Auth';

import moment from 'moment'
import Trophy from '../../assets/KarmaIcons/Trophy';
import { getResource } from '../../util/getResourcePermission';
import WaffleDashIcon from '../../assets/KarmaIcons/Spark';
import UserAvatar from '../UserAvatar';
const { Sider, Content } = Layout;
const { Title, Text } = Typography;



const { Option } = Select;
const topImages = [Top1, Top2, Top3, Top4, Top5];

// const performersData = [
//   {
//     id: 1,
//     name: 'Alex Johnson',
//     title: 'Frontend Developer',
//     points: 300,
//   },
//   {
//     id: 2,
//     name: 'Priya Mehta',
//     title: 'UX Designer',
//     points: 270,
//   },
//   {
//     id: 3,
//     name: 'John Doe',
//     title: 'Project Manager',
//     points: 250,
//   },
// ];



const Karmasend = (props) => {
  const [classToggel, setClassToggel] = useState(false);
  const [karmaistoryData, setKarmaistoryData] = useState([])
  const [performersData, setperformersData] = useState([])
  const [karmaLeaderboardData, setkarmaLeaderboardData] = useState([])
  // const [karmaistoryData, setKarmaistoryData] = useState([])
  // const [performersData, setperformersData] = useState([])
  // const [karmaLeaderboardData, setkarmaLeaderboardData] = useState([])
  const [visibleData, setVisibleData] = useState([]); // Data shown in the list
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isSendWaffleModalOpen, setisSendWaffleModalOpen] = useState(false);

  const [selectedEmployees, setSelectedEmployees] = useState([]); // ✅ State to store selected employee IDs
  const [selectedEmployeesemail, setSelectedEmployeesEmail] = useState(null); // ✅ State to store selected employee IDs


  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [catgryNAme, setCatgryNAme] = useState("");


  const [isWaffleAmountDisabled, setIsWaffleAmountDisabled] = useState(true);
  const [hasMorep, setHasMorep] = useState(true);
  const [totalRect, settotalRect] = useState(null)

  const { authUser } = useSelector(({ auth }) => auth);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 5,
  });
  const [paginationp, setPaginationp] = useState({
    current: 1,
    pageSize: 5,
  });
  const [form] = Form.useForm();
  const [empdropdown, setEmpDropdown] = useState([])

  const dispatch = useDispatch()

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const [lastRedemptionCount, setLastRedemptionCount] = useState(null);
  console.log(selectedValue, 'selectedValue');


  const [transactions, setTransection] = useState([
    { id: 1, type: 'earned', amount: 500, description: 'Welcome Bonus', date: '2024-03-15' },
    { id: 2, type: 'spent', amount: 200, description: 'Restaurant Redemption', date: '2024-03-14' },
    { id: 3, type: 'earned', amount: 150, description: 'Monthly Shopping', date: '2024-03-13' },
    { id: 4, type: 'spent', amount: 300, description: 'Gift Card Redemption', date: '2024-03-12' },
    { id: 5, type: 'earned', amount: 250, description: 'Special Promotion', date: '2024-03-11' },
  ]);

  const totalPoints = transactions.reduce((acc, curr) => {
    return curr.type === 'earned' ? acc + curr.amount : acc - curr.amount;
  }, 0);

  const totalEarned = transactions
    .filter(t => t.type === 'earned')
    .reduce((acc, curr) => acc + curr.amount, 0);

  const totalSpent = transactions
    .filter(t => t.type === 'spent')
    .reduce((acc, curr) => acc + curr.amount, 0);

  const clasRToggel = () => {
    // setClassToggel(true)
    // karmaRewardCreate()
  };


  const karmaStats = [
    {
      value: authUser?.karma_balance == -1 ? "Unlimited" : authUser?.karma_balance,
      label: 'Waffle Left',
      icon: <img src={ remaingWaffle } height={ 55 } width={ 55 } />,

    },
    {
      value: authUser?.total_remaining_karma,
      label: 'Received',
      icon: <img src={ Trophylsner } width={ 55 } height={ 55 } />,
    },
    {
      // value: authUser?.karma_sending_balance ? authUser?.karma_sending_balance : 0,
      value: authUser?.karma_sending_balance == -1 ? 'Unlimited' : authUser?.karma_sending_balance,
      label: 'Monthly Waffle',
      icon: <img src={ totalWaffel } height={ 55 } width={ 55 } />,
    },
  ];
  // Fetch all rewards
  const getKarmaRewards = async (pageNum = 1, pageLimit = 5) => {
    try {
      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.get_karma_history,
        body: {
          pageNum: pageNum,
          pageLimit: 5,
        },
      });

      if (response.status) {
        dispatch(hideAuthLoader());

        settotalRect(response?.data?.pagination?.totalRecords)
        const newData = response?.data?.data || [];
        if (pageNum === 1) {
          setKarmaistoryData(newData); // First page: Set new data
        } else {
          setKarmaistoryData((prevData) => [...prevData, ...newData]); // Append new data
        }

        // ✅ Update pagination state
        console.log(paginationp, pageNum, 'pageNum');

        setPaginationp((prev) => ({ ...prev, current: pageNum }));

        // ✅ If fewer than `pageLimit` results are returned, there’s no more data
        setHasMorep(
          newData.length === pageLimit &&
          (pageNum * paginationp.pageSize) < response?.data?.pagination?.totalRecords
        );

        console.log(newData.length === pageLimit, 'pageLimit');
      }
    } catch (error) {
      console.error("Failed to fetch rewards:", error);
    }
  };



  const performance = async () => {
    try {
      const response = await Service.makeAPICall({
        methodName: Service.getMethod,
        api_url: Service.performanceWaffle,
      });

      if (response.status) {
        dispatch(hideAuthLoader());
        // console.log(response.data.data,'performance');
        setperformersData(response?.data?.data)

        // setKarmaistoryData(response.data.data);
      }
    } catch (error) {
      console.error("Failed to fetch rewards:", error);
    }
  };


  const karmaLeaderboard = async (pageNum = 1) => {
    try {
      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.karmaLeaderboard,
        body: {
          pageNum: pageNum,
          pageLimit: 5,
        },
      });

      if (response.status) {
        dispatch(hideAuthLoader());

        const newData = response?.data?.data || [];
        if (pageNum === 1) {
          setkarmaLeaderboardData(newData); // Set full data for first load

        } else {
          setkarmaLeaderboardData((prevData) => [...prevData, ...newData]); // Append new data
        }

        // ✅ Update pagination state
        setPagination((prev) => ({ ...prev, current: pageNum }));

        // ✅ If fewer than PAGE_LIMIT results are returned, no more data is left
        setHasMore(newData.length === pagination.pageSize); console.log(newData.length === 5, 'pageLimit');

      }
    } catch (error) {
      console.error("Failed to fetch leaderboard:", error);
    }
  };


  const wafflecategry = async () => {
    try {
      const response = await Service.makeAPICall({
        methodName: Service.getMethod,
        api_url: Service.wafflecategry,
      });

      if (response.status) {
        dispatch(hideAuthLoader());
        // console.log(response.data.data,'performance');
        setSelectedCategories(response?.data?.data)

        // setKarmaistoryData(response.data.data);
      }
    } catch (error) {
      console.error("Failed to fetch rewards:", error);
    }
  };

  // Show more items when button is clicked
  const handleShowMore = () => {
    const nextPage = pagination.current + 1;
    setPagination((prev) => ({ ...prev, current: nextPage }));
    karmaLeaderboard(nextPage); // Fetch next batch
  };

  const handleShowMorePerformance = () => {
    const nextPage = paginationp.current + 1;
    setPaginationp((prev) => ({ ...prev, current: nextPage }));
    getKarmaRewards(nextPage); // Fetch next batch
  };

  const handleEconnectAPI = async (value) => {
    try {
      console.log(value, 'handleSendWaffle');

      let reqBody = {
        email: authUser?.email,
        receiver_email: selectedEmployeesemail,
        reason: catgryNAme,
      }

      // const response = await Service.makeAPICall({
      //   methodName: Service.postMethod,
      //   api_url: "http://localhost:8484/v1/sendMessageForWafflefromHRMS",
      //   body:reqBody
      // });
      const response = await axios.post(
        // "http://localhost:8484/v1/messages/sendMessageForWafflefromHRMS",
        process.env.REACT_APP_WAFFLE_FROM_HRMS,
        reqBody,
        {
          headers: {
            "Content-Type": "application/json",
            // Add Authorization if needed
            // "Authorization": `Bearer ${yourToken}`
          },
        }
      );
      console.log("-----------------------------------------------------------", response)
      if (response.data.data && response.data.status) {
        dispatch(hideAuthLoader());

        // console.log(response.data.data,'performance');
        // setperformersData(response?.data?.data)
        // message.success('Waffle successfully sent to e-connect')
        // handleSendWaffle(value)
        handleCancelWffleSend()
        // setKarmaistoryData(response.data.data);
      } else {
        message.error(response?.data?.message)

      }
    } catch (error) {
      console.error("Failed to fetch rewards:", error);
    }

  }

  const handleSendWaffle = async (value) => {
    try {
      console.log(value, 'handleSendWaffle');

      let reqBody = {
        sender_id: authUser?._id,
        receiver_ids: selectedEmployees
        ,
        transaction_type: "send_by_admin",
        message: catgryNAme,
        transaction_amount: value?.waffleAmount
      }

      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.karmaSend,
        body: reqBody
      });

      if (response.data.data) {
        dispatch(hideAuthLoader());
        // console.log(response.data.data,'performance');
        setperformersData(response?.data?.data)
        handleEconnectAPI(value)
        performance()

        // message.success('Waffle successfully sent')
        handleCancelWffleSend()
        getKarmaRewards(1, 5)

        // setKarmaistoryData(response.data.data);
      } else {
        message.error(response?.data?.message)

      }
    } catch (error) {
      console.error("Failed to fetch rewards:", error);
    }

  }


  const handleCancelWffleSend = () => {
    setisSendWaffleModalOpen(false)
    form.resetFields();
  }
  const getEmpdropdown = async () => {
    try {


      const response = await Service.makeAPICall({
        methodName: Service.getMethod,
        // api_url: isAdmin
        //   ? Service.empDropdownList
        //   : Service.empdropdownlistbyreportingmanager + "/" + authUser?._id ?
        //     Service.empdropdownlistbysubreportingmanager + "/" + authUser?._id :
        //     Service.empDropdownList
        api_url: Service.employee,

      });
      // dispatch(hideAuthLoader());
      if (response.data && response.data.data) {
        const emp = response.data.data;
        setEmpDropdown(emp);
      }
    } catch (error) {
      // dispatch(hideAuthLoader());
      console.log(error);
    }
  };


  const redeemableBalance = useMemo(() => {
    const currentCount = authUser?.total_remaining_karma || 0;
    const lastCount = lastRedemptionCount ?? 0;

    if (currentCount <= 0) {
      return 0;
    }

    return Math.max(0, currentCount - lastCount);
  }, [authUser?.total_remaining_karma, lastRedemptionCount]);

  const redemptionOptions = useMemo(() => {
    const optionCount = Math.floor(redeemableBalance / 30);
    return Array.from({ length: optionCount }, (_, idx) => (idx + 1) * 30);
  }, [redeemableBalance]);

  // Calculate if button should be disabled
  const isWaffleRewardButtonDisabled = redemptionOptions.length === 0;

  // Open Modal
  const showModal = () => {
    setSelectedValue(redemptionOptions[0] || null);
    setIsModalVisible(true);
  };

  // Handle confirmation for redemption
  const handleConfirmRedemption = async () => {
    if (!selectedValue) {
      return message.error('Select a waffle amount to redeem');
    }

    try {
      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.sendWaffleRedemptionNotification,
        body: { waffle_amount_selected: selectedValue },
      });

      if (response.status) {
        if (response.data.status === 200 || response.data.status === "success") {
          dispatch(hideAuthLoader());
          message.success('Waffle redemption notification sent successfully');
          // Refresh last redemption count after redemption
          getLastRedemptionCount();
          handleCancel();
        } else {
          message.error(response.data.message || 'Failed to send notification');
        }
      }
    } catch (error) {
      console.error("Error sending redemption notification:", error);
      message.error('Failed to send notification');
    }
  };

  // Close Modal
  const handleCancel = () => {
    setIsModalVisible(false);
    setSelectedValue(null);
  };

  // Handle Select Change
  const handleChange = (value) => {
    setSelectedValue(value);
  };
  useEffect
    (() => {
      setTimeout(() => {
        setClassToggel(false)
      }, 5000);
    }, [classToggel]);


  // Fetch last redemption count
  const getLastRedemptionCount = async () => {
    try {
      const response = await Service.makeAPICall({
        methodName: Service.getMethod,
        api_url: Service.getLastRedemptionCount,
      });

      if (response.status && response.data.status === "success") {
        setLastRedemptionCount(response.data.data.last_redemption_count ?? 0);
      }
    } catch (error) {
      console.error("Failed to fetch last redemption count:", error);
    }
  };

  useEffect(() => {
    if (isModalVisible && redemptionOptions.length && !selectedValue) {
      setSelectedValue(redemptionOptions[0]);
    }
  }, [isModalVisible, redemptionOptions, selectedValue]);

  useEffect(() => { 
    getKarmaRewards(1); 
    performance(); 
    karmaLeaderboard(1);
    getLastRedemptionCount();
  }, [])
  
  console.log(karmaistoryData, 'karmaistoryData', karmaLeaderboardData);
  function extractTextAndEmojis(htmlString) {
    const container = document.createElement("div");
    container.innerHTML = htmlString;

    let textParts = [];
    let emojiUrls = [];

    container.childNodes.forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        textParts.push(node.textContent);
      } else if (node.classList?.contains("emoji-line")) {
        // Extract inline emojis and text
        node.childNodes.forEach((child) => {
          if (child.nodeType === Node.TEXT_NODE) {
            textParts.push(child.textContent);
          } else if (child.classList?.contains("renderer_emoji")) {
            const style = child.getAttribute("style");
            const match = style?.match(/background-image:\s*url\(['"]?(.*?)['"]?\)/);
            if (match && match[1]) {
              emojiUrls.push(match[1]);
            }
          }
        });
      }
    });

    return {
      text: textParts.join("").replace(/\\n/g, "\n").trim(),
      emojiUrls
    };
  }


  return (
    <Layout className={ classToggel ? "karma-wrapper partygif" : "karma-wrapper" }>
      <img src={ partyGIF } className="gift-img" />
      <Content className="rewards-container">
        <div className="content-wrapper">
          <Card className="welcome-card">
            <div className="welcome-container">
              <div className="welcome-title ">
                <h2>
                  Waffle Dashboard! <WaffleDashIcon />
                </h2>

              </div>

              <div className="welcome-text">
                <h3>

                  Recognise effort. Reward excellence. Build a stronger Elsner.
                  {/* Recognize excellence, appreciate colleagues, and build a stronger workplace culture */ }
                </h3>
              </div>

            </div>
          </Card>

          {/* Karma Stats */ }
          <Card className="stats-card">
            <Row gutter={ [16, 16] } className='karma-card-wrapper'>
              { karmaStats.map((stat, index) => (
                <Col xs={ 24 } sm={ 8 } key={ index }>
                  <Card className="karma-stat-card">
                    <div className="karma-icon-container">{ stat.icon }</div>
                    <Title level={ 2 } className="karma-value">{ stat.value }</Title>
                    <Text type="secondary" className="karma-label">{ stat.label }</Text>
                  </Card>
                </Col>
              )) }
            </Row>
          </Card>

          {/* Action Buttons */ }
          <Row gutter={ 24 } className='karma-button-wrapper'>

            { getResource(config.RESOURCES.WAFFLE, ['create']) &&
              <Tooltip
                title="Send an Waffle to someone who made a difference. Add a personal message too!">
                <Button type="primary" icon={ <img src={ sendwaffle } width={ 20 } height={ 20 }></img> } onClick={ () => {
                  setisSendWaffleModalOpen(true);
                  getEmpdropdown(); wafflecategry()
                } } className="send-karma-btn">
                  <strong> Send Waffle</strong>


                  <div id="container-stars">
                    <div id="stars"></div>
                  </div>



                  <div id="glow">
                    <div class="circle"></div>
                    <div class="circle"></div>
                  </div>
                </Button>
              </Tooltip>

            }
              <Button
              title={ isWaffleRewardButtonDisabled
                ? `Redeem button enables when you have at least 30 redeemable waffles (available: ${redeemableBalance}).`
                : "Redeem waffles in multiples of 30 from your redeemable balance." }
                className="redeem-rewards-btn btn-shine"
                disabled={ isWaffleRewardButtonDisabled }
                onClick={ showModal }>
                <span>
                  <img src={ gift } />
                  Waffle Rewards</span>
              </Button>
          </Row>

          <Row gutter={ 24 } className='history-main-wrapper'>
            <Col xs={ 24 } lg={ 12 } >
              <Card className="stats-card top-performers-card">
                <div className="performers-header-wrapper">
                  <Tooltip title="Track every Waffle you’ve sent or received – with reason, date and messages.">
                    <div className='top-performers-header'>
                      <HistoryIcon />
                      <h2 className="history-title"> Waffle Transaction History</h2>
                    </div>
                  </Tooltip>


                </div>
                <Divider />
                <div className=" transaction-list">
                  { karmaistoryData.length > 0 ?
                    karmaistoryData?.map((transaction, index) => (
                      <> <div key={ transaction?._id } className="transaction-item">
                        <div className="transaction-info">
                          { transaction?.transaction_type == "send_by_admin" && transaction?.sender_email == authUser._id
                            ? <img src={ ltr } width={ 30 } height={ 30 } />
                            : transaction?.sender_email !== authUser._id
                              ? <UpGraph />
                              : <DownIcon />
                          }


                          <div className="transaction-details">
                            <p
                              className="transaction-description"
                              dangerouslySetInnerHTML={ {
                                __html:
                                  transaction?.message +
                                  (transaction?.transaction_type === "send_by_admin"
                                    ? `&nbsp;(Send Via HRMS)`
                                    : ""),
                              } }
                            ></p>
                            <p className="transaction-date"><span>{ transaction?.receiver_id == authUser?._id ? transaction?.sender_name : transaction?.receiver_name }</span></p>
                          </div>
                          <span className='waffle-transaction-time'>
                            { moment(new Date(transaction.createdAt)).format("DD-MM-YYYY") }</span>
                        </div>
                        <p className={ `transaction-amount ${transaction?.sender_email != authUser._id ? 'amount-earned' : 'amount-spent'
                          }` }>
                          { transaction?.transaction_type == "send_by_admin" && transaction?.sender_email == authUser._id ?
                            <>
                              <div style={ { color: '#f18f06' } }>{ transaction?.transaction_amount }</div>
                            </> :
                            <>

                              { transaction?.sender_email != authUser?._id ? '+' : '-' }{ transaction?.transaction_amount }
                            </> }
                        </p>
                      </div>
                        { index === karmaistoryData.length - 1 && hasMorep && (
                          <div style={ { textAlign: "center", marginTop: 16 } }>
                            <Button type="primary" className="redeem-button" onClick={ handleShowMorePerformance }>
                              Show More
                            </Button>
                          </div>
                        ) }</>

                    )) : <div style={ { textAlign: "center", color: '#ccc' } }>
                      <p>No Transaction History available</p>
                    </div>
                  }



                </div>
              </Card>
            </Col>
            <Col xs={ 24 } lg={ 12 }>

              <Card className="stats-card top-performers-card"
              >
                <div className='performers-header-wrapper'>
                  <Tooltip title='Meet the stars of the month – recognised by peers for going above and beyond.'>
                    <div className='top-performers-header'>
                      {/* <img  src={Trophylsner} width={40} height={40}/> */ }
                      <Trophy />
                      <h2>Top Performers</h2>
                    </div>
                  </Tooltip>

                  {/* <Select defaultValue="this-month" style={ { width: 120 } }>
                    <Option value="this-month">This Month</Option>
                    <Option value="last-month">Last Month</Option>
                    <Option value="all-time">All Time</Option>
                  </Select> */}
                </div>
                <Divider />
                <List
                  dataSource={ performersData }
                  locale={ {
                    emptyText: (
                      <div style={ { textAlign: "center" } }>
                        <p>No Performers available</p>
                      </div>
                    ),
                  } }
                  renderItem={ (item, index) => (
                    <>
                      { console.log(item, "item") }
                      <List.Item

                      >
                        <div className='performers-wrapper'>
                          <List.Item.Meta
                            avatar={
                              <>
                                <div style={ { display: 'flex', gap: '5px' } }>
                                  <Avatar
                                    src={ topImages[index] }
                                  >
                                  </Avatar>

                                  { console.log(`Top${index + 1}`, 'ttttt') }
                                  { item?.emp_img ? (
                                    <Avatar src={ `https://hrms.elsner.com/uploads/emp_images/${item?.emp_img}` } />
                                  ) : (
                                    <UserAvatar fullName={ item?.full_name } />
                                  ) }
                                </div>  {/* <Avatar
                              >
                                {index + 1}
                              </Avatar> */}
                              </>
                            }
                          />
                          <div className='performers-name-wrapper'>
                            <div className='performers-name'>
                              <h3>{ item?.full_name }</h3>
                            </div>
                            <div className='performers-title'>
                              <p>{ item?.userdepartmentDetails?.designation_name } </p>
                            </div>
                          </div>
                        </div>
                        <div className='points-wrapper'>
                          <Text >
                            { item?.total_received_karma }
                            {/* { item?.transactionCount } */ }
                          </Text>
                          <span role="img" aria-label="lightning" >
                            <img src={ Trophylsner } height={ 20 } width={ 20 } /> </span>
                        </div>
                      </List.Item>
                    </>

                  ) }

                />


              </Card>
            </Col>
          </Row>
          <Row gutter={ 24 } className='leaderboard-card-wrapper'>
            {/* Leaderboard Card */ }
            <Col xs={ 24 }>
              <Card className="stats-card leaderboard-card top-performers-card"
              >

                <div className='performers-header-wrapper'>
                  <Tooltip title="See who's climbing the Waffle leaderboard this year across teams.
">
                    <div className='top-performers-header'>
                      <Trophy />
                      <h2>Leaderboard</h2>
                    </div>
                  </Tooltip>
                </div>


                <Divider />
                <List
                  dataSource={ karmaLeaderboardData }
                  renderItem={ (item, index) => (
                    <>
                      <List.Item>
                        <div className='performers-wrapper'>
                          <List.Item.Meta
                            avatar={
                              item?.emp_img ? <Avatar src={ "https://hrms.elsner.com/uploads/emp_images/" + item?.emp_img } /> : <UserAvatar fullName={ item?.full_name } />
                            }
                          />
                          <div className='performers-name-wrapper'>
                            <div className='performers-name'>
                              <h3>{ item?.full_name }</h3>
                            </div>
                            <div className='performers-title'>
                              <p>{ item?.designation?.designation_name }</p>
                            </div>
                          </div>
                        </div>
                        <div className='points-wrapper'>
                          <Text>{ item?.total_received_karma || 0 }</Text>
                          <span role="img" aria-label="lightning"><img src={ Trophylsner } height={ 20 } width={ 20 } alt='emp_img' /> </span>
                        </div>
                      </List.Item>

                      {/* ✅ Show "Show More" button after every 5th item */ }
                      { index === karmaLeaderboardData.length - 1 && hasMore && (
                        <div style={ { textAlign: "center", marginTop: 16 } }>
                          <Button type="primary" className="redeem-button" onClick={ handleShowMore }>
                            Show More
                          </Button>
                        </div>
                      ) }

                    </>
                  ) }
                />
              </Card>
            </Col>
          </Row>

          <Modal
            className='waffle-modal'
            title="Send Waffle"
            open={ isSendWaffleModalOpen }
            onCancel={ handleCancelWffleSend }
            footer={ null }
          >
            <Form form={ form } layout="vertical" onFinish={ handleSendWaffle }>

              {/* Employee Dropdown */ }
              <Form.Item label="Employee" name="employee" required={ true }>
                <Select
                  size="large"
                  showSearch
                  optionFilterProp="children"
                  filterOption={ (input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  filterSort={ (optionA, optionB) =>
                    optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                  }
                  placeholder="Select an employee"
                  onChange={ (selectedId) => {
                    setSelectedEmployees([selectedId]); // Store as an array with one value
                    let selectedEmployee = empdropdown.find((emp) => emp._id === selectedId);
                    let employeeCode = selectedEmployee ? selectedEmployee?.email : "";
                    setSelectedEmployeesEmail(employeeCode)

                    form.setFieldsValue({ employee_code: [selectedId] });
                  } }
                >
                  { empdropdown.map((item) => (
                    <Option key={ item._id } value={ item._id } style={ { textTransform: "capitalize" } }>
                      { item.first_name + " " + item.last_name }
                    </Option>
                  )) }
                </Select>
              </Form.Item>


              {/* Category Dropdown */ }
              <Form.Item name="category" label="Select Category" rules={ [{ required: true, message: "Please select a category!" }] }>
                <Select
                  placeholder="Choose a category"
                  onChange={ (selectedCategory) => {
                    const selected = selectedCategories.find((cat) => cat._id === selectedCategory);
                    setCatgryNAme(selected.category)
                    form.setFieldsValue({ waffleAmount: selected ? selected.waffle_count : null });
                    setIsWaffleAmountDisabled(!selected); // Enable if category selected
                  } }
                >
                  { selectedCategories.map((category) => (
                    <Option key={ category._id } value={ category._id }>
                      { category?.category }
                    </Option>
                  )) }
                </Select>
              </Form.Item>

              {/* Message Input */ }
              <Form.Item name="message" label="Message" rules={ [{ required: true, message: "Please enter a message!" }] }>
                <Input.TextArea placeholder="Write a message..." rows={ 3 } />
              </Form.Item>

              {/* Waffle Amount - Disabled Until Category is Selected */ }
              <Form.Item
                name="waffleAmount"
                label="Waffle Amount"
                rules={ [{ required: true, message: "Enter waffle amount!" }] }
              >
                <InputNumber
                  min={ 1 }
                  max={ 100 }
                  style={ { width: "100%" } }
                  disabled={ true } // Disable when no category is selected
                />
              </Form.Item>

              <div>
                <Button key="cancel" className='delete-btn' onClick={ handleCancelWffleSend }>
                  Cancel
                </Button>
                <Button key="send" type="primary" className='redeem-button' htmlType="submit" style={ { marginLeft: '10px' } } >
                  Send Waffle
                </Button>
              </div>

            </Form>
          </Modal>

          <Modal
            className='waffle-modal'
            title="Redeem Waffles"
            open={ isModalVisible }
            onCancel={ handleCancel }
            footer={ [
              <Button key="cancel" className='delete-btn' onClick={ handleCancel }>
                Cancel
              </Button>,
              <Button
                key="submit"
                type="primary"
                className='redeem-button'
                disabled={ isWaffleRewardButtonDisabled || !selectedValue }
                onClick={ handleConfirmRedemption }>
                Redeem
              </Button>,
            ] }
          >
            <p>Redeemable waffles available: <strong>{ redeemableBalance }</strong></p>
            { redemptionOptions.length ? (
              <Select
                required={ true }
                placeholder="Select a value"
                style={ { width: "100%" } }
                value={ selectedValue }
                onChange={ handleChange }
              >
                { redemptionOptions.map((value) => (
                  <Option key={ value } value={ value }>
                    { value }
                  </Option>
                )) }
              </Select>
            ) : (
              <Text type="secondary">Earn at least 30 redeemable waffles to proceed.</Text>
            ) }
          </Modal>
        </div>

      </Content>
    </Layout>
  );
};

export default Karmasend;
